import { GitBranch, History, Plus } from 'lucide-react';
import { Link, Outlet, useLocation } from 'react-router-dom';

import { cn } from '@/lib/utils';
import { buttonVariants } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

import { ScrollArea } from '../ui/scroll-area';

const WorkflowLayout = () => {
  const navConfig = {
    Main: [
      {
        title: 'All Workflows',
        href: '/workflows',
        icon: GitBranch,
      },
      {
        title: 'Workflow Runs',
        href: '/workflows/runs',
        icon: History,
      },
    ],
  };

  return (
    <div className='hidden h-svh space-y-6 md:block'>
      <div className='flex h-full flex-col space-y-8 lg:flex-row lg:space-x-4 lg:space-y-0'>
        <aside className='space-y-2 px-6 py-4 lg:min-w-[300px] lg:max-w-[300px]'>
          <div className='space-y-0.5'>
            <h2 className='text-xl font-bold tracking-tight'>Workflows</h2>
            <p className='text-muted-foreground'>
              Manage your automation workflows
            </p>
          </div>
          <SidebarNav navConfig={navConfig} />
        </aside>
        <Separator orientation='vertical' />
        <div className='flex-1'>
          <ScrollArea className='h-full'>
            <div className='p-5'>
              <Outlet />
            </div>
          </ScrollArea>
        </div>
      </div>
    </div>
  );
};

export default WorkflowLayout;

function SidebarNav({ className, navConfig, ...props }) {
  const location = useLocation();
  const { pathname } = location;

  return (
    <nav
      className={cn(
        'flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1',
        className
      )}
      {...props}
    >
      <ul role='list' className='space-y-1'>
        {Object.keys(navConfig).map((section) => (
          <li key={section}>
            <div className='my-5 space-y-3'>
              {navConfig[section].map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className={cn(
                    buttonVariants({ variant: 'ghost' }),
                    pathname === item.href
                      ? 'bg-muted hover:bg-muted'
                      : 'hover:bg-muted',
                    'w-full justify-start'
                  )}
                >
                  <span className='flex items-center'>
                    {item.icon && <item.icon className='mr-2 h-4 w-4' />}
                    <span className='truncate'>{item.title}</span>
                  </span>
                </Link>
              ))}
            </div>
          </li>
        ))}
      </ul>
    </nav>
  );
}
